import React, {useState, useEffect, useCallback} from 'react';
import {useFormikContext} from 'formik';
import _, {isEmpty} from 'lodash';

/**
 * Auto submit formik
 *
 * @param onReadyStateChange
 * @param formik
 * @returns {null}
 * @constructor
 */
const AutoSubmitFormik = ({onReadyStateChange, formik}) => {

	const [lastValues, updateState] = useState(formik.values);

	useEffect(() => {

		const valuesEqualLastValues = _.isEqual(lastValues, formik.values);
		const valuesEqualInitialValues =
			formik.values === formik.initialValues;

		if (!valuesEqualLastValues) {
			updateState(formik.values);
		}

		formik.validateForm().then(res => {
			if ((Object.keys(res).length == 0 && Object.keys(formik.touched).length >= 0)) {
				onReadyStateChange('ready', true, formik.values)
				formik.submitForm();
			} else {
				onReadyStateChange('wait', false, formik.values)
			}
		}).catch(error => {
			console.log(error);
		})


	}, [

		formik.values
	]);

	return null;


}

export default AutoSubmitFormik
